import snakeCase from 'lodash/snakeCase';

type StringOrNumberValueDataKeys<T> = keyof {
  [K in keyof T as NonNullable<T[K]> extends string | number ? K : never]: any;
} &
  string;

// use data from api, e.g. { siteName: 'BairesDev' } and return
// formatted data for meta props: [{property: 'og:site_name', content: 'BairesDev'}]
// this will be called multiple times because of different prefixes

const getMetaProps = <T extends Record<string, any>>(
  obj: T | null | undefined,
  keys: readonly StringOrNumberValueDataKeys<T>[],
  prefix = 'og',
  attribute = 'property',
): Record<string, string>[] =>
  obj
    ? keys.reduce((acc: Record<string, string>[], curr) => {
        if (obj[curr]) {
          acc.push({ [attribute]: `${prefix}:${snakeCase(curr)}`, content: obj[curr] });
        }
        return acc;
      }, [])
    : [];

export default getMetaProps;
